import {
  initialState,
  Actions,
  State,
  EDIT_RESPONSIBLE_TYPES,
  EDIT_RESPONSIBLE_TYPES_SUCCESS,
  EDIT_RESPONSIBLE_TYPES_ERROR,
  RESET_EDIT_RESPONSIBLE_TYPES,
} from '../../types/responsible/edit-responsible-types'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_RESPONSIBLE_TYPES:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_RESPONSIBLE_TYPES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_RESPONSIBLE_TYPES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_RESPONSIBLE_TYPES:
      return initialState
    default:
      return state
  }
}

export default reducers
